import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';

import clienteService from '../../../service/administracion/clienteService';
import { FACTURA } from '../../../common/types/tipoComprobanteType';

import cuentasCobrarService from '../../../service/tesoreria/cuentasCobrar';
import auth from '../../../common/utility/auth';
import comprobanteService from '../../../service/ventas/comprobanteService';
import metodoPagoService from '../../../service/administracion/metodoPagoService.js';

import cuentaService from '../../../service/administracion/cuentaService';
import ReporteCuentasCobrarService from '../../../service/creditoCobranza/ReporteCuentasCobrarService.js';
import empresaService from '../../../service/administracion/empresaService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
import ResultListResumen from './ResultListResumen';
import ResultListDetalle from './ResultListDetalle';
import ViewModal from './ViewModal';
import ViewResumen from './ViewResumen';

import PrintModal from './PrintModal';
import ImprimirModal from './ImprimirModal';

import ViewPago from './ViewPago';
import printFormatMock from '../../../common/mock/printFormatMock';


export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingImprimir: false,
            loadingPrint: false,
            loadingVer: false,
            viewVisible: false,
            viewPagoVisible: false,
            viewResumen: false,
            viewHistorialVisible: false,
            clientes: [],
            listaEstadoPago: [],
            listaMetodoPago: [],
            listaCuentaDestino: [],
            listaTipoComprobante: [],
            listaEstadoPagoDetalle: [],
            company: {},
            imprimirFormValues: {
                file: undefined,
                idComprobante: 0,
                idFormato: 0,
                formatos: printFormatMock.values,
                serieCorrelativo: ''
            },

            viewFormValues: {},
            estados: estadoMock.values,
            filter: {
                idTipoComprobante: 0,
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                tipoReporte: 0,
                serie: '',
                cliente: '',
                IdEstado: 0,
                estado: '',
                idCliente: 0,
                documento: '',
                ...FILTER
            },
            pagination: PAGINATION,
            paginationResumen: PAGINATION,
            paginationDetallado: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: "",
            idDocumentoElctronico: 0,
            idCuentasCobrarDetalle: 0,
            DocumentoCliente: '',
            RazonSocialClientemento: '',
            Moneda: '',
            Monto: 0,
            nroCouta: 0,
            Fecha: global.fetchCurrentDateStr(),
            listaFormaPago: [],
            listaMetodoPago: [],
            listaCuentaDestino: []

        }
    };

    handleClearFilters = () => {
        var filter = {
            idTipoComprobante: 0,
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            tipoReporte: 0,
            serie: '',
            cliente: '',
            IdEstado: 0,
            estado: '',
            idCliente: 0,
            documento: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        debugger
        e.preventDefault();
        if (e.keyCode === 13) {
            this.ChangePaginationGetData();
        }
    };

    handleChange = async (property, value, texto, param) => {
        const filter = { ...this.state.filter, [property]: value };
        if (texto != null) {
            var value = texto.label;
            filter[param] = value;
        }
        this.setState({ filter: filter });
        debugger
        if (property === "tipoReporte") {

            var response = undefined;
            if (value == 1) {

                var response = await cuentasCobrarService.cuentasResumen(filter);

                this.setState({
                    paginationResumen: response == undefined ? [] : response
                })
            } if (value == 2) {
                const filter = { ...this.state.filter };
                filter.IdEstado = 0;


                var response = await cuentasCobrarService.cuentasDetallado(filter);
                this.setState({
                    paginationDetallado: response == undefined ? [] : response
                })
            }
            if (value == 0) {

                var response = await cuentasCobrarService.paginacion(filter);
                this.setState({
                    pagination: response == undefined ? [] : response
                })
            }

        }

    };


    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await cuentasCobrarService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Cuentas por Cobrar.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await cuentasCobrarService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Cuentas por Cobrar.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await cuentasCobrarService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    /******************** FORM MODAL *****************/

    obtenerDatosIniciales = async () => {
        const datosInicialesFilter = {
            idUsuario: auth.user().id,
            idTipoComprobante: FACTURA.ID
        }
        const datosIniciales = await comprobanteService.datosIniciales(datosInicialesFilter);

        return datosIniciales;
    }

    handleSave = (values, form) => {
        debugger
        console.log(values);
        var data = values;

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            response = await cuentasCobrarService.registrar(values);


            if (response.status === 200) {
                form.resetFields();
                this.setState({ viewPagoVisible: false });
                message.success('Registrado' + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    //#region MODAL VIEW 

    handleView = async (item) => {
        debugger
        this.setState({ loadingVer: true });
        var response = await cuentasCobrarService.ver({ id: item.id });
        if (response !== undefined) {

            this.setState({
                loadingVer: false,
                viewVisible: true,
                viewFormValues: {
                    DocumentoCliente: item.numeroDocumentoCliente,
                    RazonSocialClientemento: item.razonSocialCliente,
                    FechaTipoCambio: item.fechaStr,
                    TipoCambio: item.tipoCambio,
                    Serie: item.nroSerie,
                    NumeroDocumento: item.serieDocumentoComprobante,
                    Correlativo: item.correlativo,
                    Dias: 0,
                    Monto: item.moneda.charAt(0) == "S" ? item.totalSoles : item.totalDolares,
                    Saldo: item.moneda.charAt(0) == "S" ? item.saldoSoles : item.saldoDolares,
                    ImporteCancelado: item.moneda.charAt(0) == "S" ? item.canceladoSoles : item.canceladoDolares,
                    FechaVencimiento: item.fechaVencemientoStr,
                    Moneda: item.moneda,
                    detalles: response

                }
            });
        }
    }


    handleHistorial = async (item) => {
        debugger
        this.setState({ loadingVer: true });
        var response_historial_pago = await cuentasCobrarService.verPago({ id: item.id });
        var response_cuota = await cuentasCobrarService.ver({ id: item.id });

        if (response_historial_pago !== undefined || response_cuota !== undefined) {

            this.setState({
                loadingVer: false,
                viewHistorialVisible: true,
                viewFormValues: {
                    idDocumentoElctronico: item.id,
                    DocumentoCliente: item.numeroDocumentoCliente,
                    RazonSocialClientemento: item.razonSocialCliente,
                    FechaTipoCambio: item.fechaStr,
                    TipoCambio: 0,
                    Serie: item.serie,
                    NumeroDocumento: item.serieDocumentoComprobante,
                    Correlativo: item.documento,
                    Dias: 0,
                    Monto: item.moneda.charAt(0) == "S" ? (item.totalSoles).toFixed(2) : (item.totalSoles).toFixed(2),
                    Saldo: item.moneda.charAt(0) == "S" ? item.saldoSoles : item.totalSoles,
                    ImporteCancelado: item.moneda.charAt(0) == "S" ? item.canceladoSoles : item.canceladoDolares,
                    FechaVencimiento: item.fechaVencemientoStr,
                    Moneda: item.moneda,
                    lst_historialPago: response_historial_pago,
                    detalles: response_cuota,


                }
            });
        }
    }



    handleViewPago = async (item) => {
        debugger
        var data_pago = this.state.pagination.data.filter(data => data.id === parseInt(item.idCuentasCobrar));

        var response_historial_pago = await cuentasCobrarService.verPago({ id: item.idCuentasCobrar });
        if (response_historial_pago.length > 0)
            response_historial_pago = response_historial_pago.filter(data => data.nroCouta === item.nroCouta);

        if (data_pago !== undefined) {

            var metodo_pago = this.state.listaMetodoPago;
            var cuenta_destino = this.state.listaCuentaDestino;

            this.setState({
                loadingVer: false,
                viewVisible: false,
                viewPagoVisible: true,
                formValues: {
                    idDocumentoElctronico: data_pago[0].id,
                    idCuentasCobrarDetalle: parseInt(item.idCuentasCobrarDetalle),
                    DocumentoCliente: data_pago[0].numeroDocumentoCliente,
                    RazonSocialClientemento: data_pago[0].razonSocialCliente,
                    Moneda: data_pago[0].moneda,
                    Monto: (item.total).toFixed(2),
                    nroCouta: item.nroCouta,
                    Fecha: global.fetchCurrentDateStr(),
                    listaFormaPago: [],
                    listaMetodoPago: metodo_pago,
                    listaCuentaDestino: cuenta_destino,
                    lst_historialPago: response_historial_pago,

                }
            });


        }
    }




    handleAddFormaPago = () => {
        debugger
        var listaFormaPago = this.state.formValues.listaFormaPago;

        listaFormaPago.push({
            identifier: global.fetchUniqueCode(),
            fecha: global.fetchCurrentDateStr(),
            idMetodoPago: 0,
            idDestino: 0,
            referencia: '',
            montoCuota: 0
        });


        this.setState({
            formValues: {
                ...this.state.formValues,
                listaFormaPago: listaFormaPago
            }
        });


    };



    handleRemoverFormaPago = (item) => {
        debugger
        var lista_FormaPago = this.state.formValues.listaFormaPago.filter(m => m.identifier !== item.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaFormaPago: lista_FormaPago
            }
        });


    };

    handleResumen = async (item) => {
        debugger
        var cuota = parseInt(item.cuota);
        var responsePago = await cuentasCobrarService.verPago({ id: item.id });
        if (responsePago !== undefined) {

            this.setState({
                loadingVer: false,
                viewResumen: true,
                viewFormValues: {
                    idDocumentoElctronico: item.id,
                    DocumentoCliente: item.numeroDocumentoCliente,
                    RazonSocialClientemento: item.razonSocialCliente,
                    fecha: item.fechaStr,
                    tipoCambio: (item.tipoCambio).toFixed(3),
                    Serie: item.serie,
                    NumeroDocumento: item.serieDocumentoComprobante,
                    Correlativo: item.documento,
                    cuota: item.cuota,
                    Monto: item.moneda.charAt(0) == "S" ? (item.totalSoles).toFixed(2) : (item.totalDolares).toFixed(2),
                    Saldo: item.saldo,
                    fechaStr: item.fechaStr,
                    ImporteCancelado: item.total - item.saldo,
                    fechaVencimiento: item.fechaVencemientoStr,
                    Moneda: item.moneda,
                    lst_historialPago: responsePago.length > 0 ? responsePago.filter(e => e.nroCouta == cuota) : []
                }
            });
        }
    }

    //#endregion MODAL


    //#region Imprimir 


    handleImprimir = async (item) => {

        this.setState({ loadingImprimir: true });
        var file = undefined;
        var response = undefined;
        var idFormato = this.state.company.formatoPrint;

        if (idFormato === 1) {
            response = await cuentasCobrarService.pdfA4({ id: item });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await cuentasCobrarService.ticket({ id: item });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 3) {
            response = await cuentasCobrarService.ticket50({ id: item });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            loadingImprimir: false,
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file,
                idComprobante: item
            },
            selectedItem: item
        });
    };

    handleChangeImprimir = async (idFormato) => {
        var file = undefined;
        var response = undefined;
        if (idFormato === 1) {
            response = await cuentasCobrarService.pdfA4({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await cuentasCobrarService.ticket({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 3) {
            response = await cuentasCobrarService.ticket50({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file
            }
        });
    };

    handleDownloadPdf = async () => {

        var response = undefined;
        var file = undefined;

        if (this.state.imprimirFormValues.idFormato === 1) {
            response = await cuentasCobrarService.pdfA4({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (this.state.imprimirFormValues.idFormato === 2) {
            response = await cuentasCobrarService.ticket({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (this.state.imprimirFormValues.idFormato === 3) {
            response = await cuentasCobrarService.ticket50({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (response !== undefined)
            global.dowloadFile(response.data, this.state.viewFormValues.NumeroDocumento + ".pdf");
    };


    //#endregion Imprimir

    //#region "Filter"

    ChangePagination = async (pagination) => {
        debugger
        const filter = { ...this.state.filter, ...pagination };
        this.setState({ filter: filter });

        setTimeout(() => {
            this.ChangePaginationGetData();
        }, 100);

    }

    ChangePaginationGetData = async () => {
        var response = undefined;

        if (this.state.filter.tipoReporte == 0) {
            //response = await cuentasCobrarService.pagination({ ...this.state.filter });
            this._initPagination({ ...this.state.filter }, ReporteCuentasCobrarService.paginacion);

            this.setState({
                //pagination: response,
                ltsPlanilla: false
            })

            this.setState({
                isCabecera: true,
                ListCabecera: true,
                ListDetalle: false,
                isRegresar: true,
            });
            return false;
        }



        if (this.state.filter.tipoReporte != 0) {

            if (this.state.filter.tipoReporte == 1) {
                response = await cuentasCobrarService.cuentasResumen({ ...this.state.filter });

                this.setState({
                    paginationResumen: response == undefined ? [] : response,
                })
            } else {
                const filter = { ...this.state.filter };
                filter.IdEstado = 0;
                //filter.page=1; 

                response = await cuentasCobrarService.cuentasDetallado(filter);
                this.setState({
                    paginationDetallado: []
                })

                setTimeout(() => {

                    this.setState({
                        paginationDetallado: response == undefined ? [] : response,
                    })
                }, 200)
            }
        }
    }


    //#endregion ""

    async componentDidMount() {
        const empresa = await empresaService.obtenerPrincipal(0);

        const metodoPagos = await metodoPagoService.listar();
        const cuentaDestino = await cuentaService.listar_select();

        this._initPagination({ ...this.state.filter }, ReporteCuentasCobrarService.paginacion);
        const estadoPagar = await cuentasCobrarService.listar_estados_cuentas();

        const estadoPagarDetalle = [{ 'id': 1, 'nombre': 'CANCELADO' }, { 'id': 2, 'nombre': 'PENDIENTE' }, { 'id': 3, 'nombre': 'CANCELADO PARCIAL' }]
        const clientes = await clienteService.listar();


        this.setState({
            loadingSource: false,
            clientes: clientes ? clientes : [],
            listaMetodoPago: metodoPagos ? metodoPagos : [],
            listaCuentaDestino: cuentaDestino ? cuentaDestino : [],
            listaEstadoPago: estadoPagar ? estadoPagar : [],
            listaEstadoPagoDetalle: estadoPagarDetalle ? estadoPagarDetalle : [],
            company: empresa,

            listaTipoComprobante: [{ 'id': 2, 'nombre': 'FACTURA' }, { 'id': 4, 'nombre': 'BOLETA' }, { 'id': 97, 'nombre': 'NOTA VENTA' }]

        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Reporte Cuentas por Cobrar"
                    onSearch={this.ChangePaginationGetData}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    clientes={this.state.clientes}
                    estado={this.state.listaEstadoPago}
                    estadoDetalle={this.state.listaEstadoPagoDetalle}
                    listaTipoComprobante={this.state.listaTipoComprobante}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />

                {(() => {
                    if (this.state.filter.tipoReporte == 0) {
                        return <ResultList
                            pagination={this.state.pagination}
                            loadingEdit={this.state.loadingSource}
                            loadingExcel={this.state.loadingExcel}
                            loadingPdf={this.state.loadingPdf}
                            loadingPrint={this.state.loadingPrint}
                            onExportExcel={this.handleExportExcel}
                            onExportPdf={this.handleExportPdf}
                            onPrint={this.handlePrint}
                            onView={this.handleView}
                            onHistorial={this.handleHistorial}
                            onChange={this.ChangePagination}
                        />
                    }

                    return (
                        <div>
                            {this.state.filter.tipoReporte == 1 ?
                                <ResultListResumen
                                    pagination={this.state.paginationResumen}
                                    loadingEdit={this.state.loadingSource}
                                    loadingExcel={this.state.loadingExcel}
                                    loadingPdf={this.state.loadingPdf}
                                    loadingPrint={this.state.loadingPrint}
                                    //onExportExcel={this.handleExportExcel}
                                    //onExportPdf={this.handleExportPdf}
                                    //onPrint={this.handlePrint}
                                    onHistorial={this.handleResumen}
                                    onChange={this.ChangePagination}
                                />
                                :
                                <ResultListDetalle
                                    pagination={this.state.paginationDetallado}
                                    loadingEdit={this.state.loadingSource}
                                    loadingExcel={this.state.loadingExcel}
                                    loadingPdf={this.state.loadingPdf}
                                    loadingPrint={this.state.loadingPrint}
                                    //onExportExcel={this.handleExportExcel}
                                    //onExportPdf={this.handleExportPdf}
                                    //onPrint={this.handlePrint}
                                    onChange={this.ChangePagination}
                                />
                            }
                        </div>
                    )
                })()}

                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />

                <ViewModal
                    visible={this.state.viewVisible}
                    formValues={this.state.viewFormValues}
                    onClose={() => this.setState({ viewVisible: false })}
                    onViewPago={this.handleViewPago}
                />

                <PrintModal
                    visible={this.state.viewHistorialVisible}
                    formValues={this.state.viewFormValues}
                    onClose={() => this.setState({ viewHistorialVisible: false })}
                    onImprimir={this.handleImprimir}
                />

                <ViewResumen
                    visible={this.state.viewResumen}
                    formValues={this.state.viewFormValues}
                    onClose={() => this.setState({ viewResumen: false })}
                    onImprimir={this.handleImprimir}
                />

                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onDownload={this.handleDownloadPdf}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />

                <ViewPago
                    onRemoverFormaPago={this.handleRemoverFormaPago}
                    onAgregarDetalle={this.handleAddFormaPago}
                    onSave={this.handleSave}
                    visible={this.state.viewPagoVisible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ viewPagoVisible: false })}
                />

            </div>
        );
    };
}